export default {
  username: "账号",
  userAccount: "账号",
  password: "密码",
  accountPassword: "密码",
  idName: "姓名",
  idNumber: "身份证号码",
  iconPhone: "手机号码",
  iconPhoneCode: "验证码",
  telCode: "验证码",
  boundiconPhone: "已绑手机",
  currentPassword: "当前密码",
  newPassword: "新密码",
  typeProblem: "问题类型",
  server: "服务器",
  characterName: "角色名称",
  problemDes: "问题描述",
  verificationCode: "验证码",
  telphone: "手机号码",
  bindPhone: "绑定手机",
  appealNumber: "申诉工单号",
  bindEmail: "绑定邮箱",
  emailAddress: "邮箱地址",
  addresss: "收件地址",
  name: "姓名",
};
